/* eslint-disable */
import React from 'react';
import styled from 'styled-components';

import withI18n from '../../../utils/withI18n';
import { getLabel } from '../../../utils/i18n';
import FlexBox from '../../FlexBox';
import Icon from '../../Icon';

import listData from './listsData';

const WrapperBox = styled(FlexBox)`
  width: 100%;
  background: #0b0e11;
`;

const Content = styled.div`
  max-width: 1260px;
  margin: 0 auto;
  font-family: ${({ theme }) => theme.fontIBMLight};
  padding: 0 0 200px 0;
`;

const List = styled.div`
  height: auto;
  overflow: hidden;
  padding: 200px 0 0 0;
  > h2 {
    font-size: 54px;
    font-weight: 200;
    color: #fff !important;
    margin: 0;
    padding: 0;
    font-family: ${({ theme }) => theme.fontIBMLight};
  }
  > p {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
    margin: 25px 0 100px 0;
    padding: 0;
    font-weight: 500;
    font-family: ${({ theme }) => theme.fontIBMMedium};
  }
`;
const Item = styled(FlexBox)`
  height: auto;
  overflow: hidden;
  > div {
    width: 610px;
    height: 400px;
    border: 1px solid rgba(234, 236, 239, 0.1);
    margin-bottom: 40px;
    color: rgba(255, 255, 255, 0.6);
    position: relative;
    overflow: hidden;
    img {
      max-width: 100%;
    }
    &:hover {
      > .mask {
        transition: all 0.5s;
        opacity: 1;
      }
      > .bg-img img {
        transition: all 0.5s;
        transform: scale(1.2);
        max-width: 100%;
      }
    }
    > .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 2;
      background: rgba(0, 0, 0, 0.6);
      opacity: 0;
      transition: all 0.5s;
    }
    > .bg-img {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
      > img {
        transition: all 0.5s;
      }
    }
    > .content {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 3;
      padding: 40px;
      > h3 {
        font-size: 34px;
        margin: 0;
        padding: 0;
        font-family: ${({ theme }) => theme.fontIBMSemiBold};
        .iconfont {
          font-size: 36px;
          margin-right: 25px;
        }
      }
      > p {
        margin: 15px 0;
        font-size: 14px;
        font-weight: 500;
      }
      > a {
        color: rgba(255, 255, 255, 0.6);
        font-size: 14px;
        text-decoration: none;
        font-weight: 500;
      }
    }
  }
`;

type Props = {
  i18n: Object,
  locale: string,
};

export default
@withI18n
class Lists extends React.Component<Props> {
  static defaultProps = {
    i18n: {},
    locale: 'en',
  };

  render() {
    const { i18n, locale } = this.props;
    const lists = listData;
    return (
      <WrapperBox direction="column">
        <Content>
          {lists.map((item, i) => (
            <List key={i}>
              <a id={`scroll_${i + 1}`} rel="external nofollow" />
              <h2>{getLabel(item.title, i18n)}</h2>
              <p>{getLabel(item.description, i18n)}</p>
              <Item justify="space-between">
                {item.list.map((list, index) => (
                  <div key={index}>
                    <div className="mask" />
                    <div className="bg-img">
                      <img src={`${require('./imgs/' + list.bgImg)}`} alt={getLabel(item.title, i18n)} />
                    </div>
                    <div className="content">
                      <h3>
                        <Icon type={list.icon} />
                        {getLabel(list.name, i18n)}
                      </h3>
                      <p>{getLabel(list.des, i18n)}</p>
                      <a id={list.listsDataId} href={list.url} target="_blank">
                        {getLabel('exchange-common-learnMore', i18n)} {'>>'}
                      </a>
                    </div>
                  </div>
                ))}
              </Item>
            </List>
          ))}
        </Content>
      </WrapperBox>
    );
  }
}
